import { JSX, ReactNode } from 'react';
import { Box, Flex, Radio, Text, Tooltip } from '@chakra-ui/react';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  value: string;
  // student?: any;
  label: string;
  subLabel?: string;
  info?: ReactNode;
};

export function RadioOptionWithLabel({ label, subLabel, value, info }: Props): JSX.Element {
  return (
    <>
      <Box py={0.5} px={4} borderWidth="1px" borderRadius="md" _hover={{ bg: 'gray.50' }}>
        <Flex justifyContent="space-between" alignItems="flex-start">
          <Radio size="lg" value={value}>
            <Flex direction="column">
              <Text fontWeight="500" size="lg" marginBottom={0}>
                {label}
              </Text>
              {subLabel && (
                <Text size="xs" fontSize="sm" color="muted" marginBottom={0}>
                  {subLabel}
                </Text>
              )}
            </Flex>
          </Radio>

          {info && (
            <Box py={2}>
              <Tooltip hasArrow placement="top" label={info}>
                <FontAwesomeIcon color="#00113380" icon={faCircleInfo} size="sm" />
              </Tooltip>
            </Box>
          )}
        </Flex>
      </Box>
    </>
  );
}
